import React from "react";

function OutroA({ text }) {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        boxSizing: "border-box",
        padding: "24px 8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          padding: "24px 32px",
          marginRight: 40,
        }}
      >
        <img
          src={"/assets/walkthrough/ECHO.svg"}
          alt="ECHO Logo"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          background: "#fff",
          borderRadius: 0,
          boxShadow: "0 2px 12px rgba(0,0,0,0.10)",
          padding: "32px 46px",
          minWidth: 320,
          maxWidth: 480,
          minHeight: 150,
        }}
      >
        {/* Message box */}
        <div
          style={{
            fontSize: 40,
            color: "#222",
            fontWeight: 400,
            lineHeight: 1.4,
            wordBreak: "break-word",
          }}
        >
          {text}
        </div>
      </div>
    </div>
  );
}

export default OutroA;
